var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurveLines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 73,
    viewBox: "0 0 101 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 664"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 140",
    d: "M46.1131 58.6836C47.3789 55.8259 52.3882 49.4072 55.2971 48.1047C61.8519 45.1695 65.2035 44.1596 71.6989 47.2267",
    stroke: "#F8BF3E",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 141",
    d: "M85.6128 33.5565C80.4008 25.2659 62.1736 27.0369 50.8888 32.09C48.4401 33.1865 43.4785 34.6693 41.696 36.49C40.6089 37.6004 38.9934 38.4108 37.8435 39.507C36.5549 40.7353 35.7364 42.2581 34.4023 43.4427C29.118 48.1344 25.2452 55.7334 25.1427 61.2011",
    stroke: "#F8BF3E",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 142",
    d: "M94.577 20.3835C87.204 8.63373 61.5169 11.0824 45.6261 18.198C42.1778 19.7421 35.1888 21.8249 32.682 24.3959C31.1531 25.964 28.8786 27.1058 27.2611 28.6535C25.4486 30.3878 24.2998 32.5403 22.4229 34.2125C14.9891 40.8357 9.55426 51.5778 9.4271 59.3157",
    stroke: "#F8BF3E",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurveLines);
export default __webpack_public_path__ + "static/media/curve-lines.3047a8583b98734a23eec65422bc5c3c.svg";
export { ForwardRef as ReactComponent };